import { combineEpics } from 'redux-observable'
import { STOP_FADER_DRAWER, showStopFaderDrawer, hideDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import MobileDetect from 'aria-viewer/utils/mobileDetect'

import 'rxjs/add/operator/delay'
import 'rxjs/add/operator/mapTo'
import 'rxjs/add/operator/take'
import 'rxjs/add/operator/takeUntil'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/skip'
import { observeFirstSceneEntered, isActionType } from 'aria-viewer/utils/epicsCommon'
import { firstStopViewed } from 'aria-viewer/tour/tourActions'
import { MainMediaActions } from 'aria-viewer/media'

const firstStopVieweed = (action$, store) =>
    observeFirstSceneEntered(action$, store, 500)
        .take(1)
        .mapTo(firstStopViewed())

// wait 1 seconds, to prevent scene overloading (too much too fast)
const stopDrawerAutoShow = (action$, store) =>
    observeFirstSceneEntered(action$, store, 4000)
        .skip(MobileDetect.mobile())
        .take(1)
        .mapTo(showStopFaderDrawer())
        .takeUntil(action$.ofType(MainMediaActions.MAIN_MEDIA_CLICKED))

const stopDrawerAutoDismissEpic = (action$, store) => {
    return (
        action$
            // Observe when stop drawer fader is first presented.
            .filter(action => isActionType(action, STOP_FADER_DRAWER))
            .delay(2000) // wait 2 seconds
            // Only auto dismiss after first show, as this is triggered by the system.
            .take(1)
            // close the drawer
            .mapTo(hideDrawer())
            // Cancel observable when stop_fader is presented again from user or main media has been interacted with
            .takeUntil(
                action$.filter(
                    action =>
                        (action.type == STOP_FADER_DRAWER && action.userTriggered) ||
                        action.type == MainMediaActions.MAIN_MEDIA_CLICKED
                )
            )
    )
}

const stopDrawerEpics = combineEpics(stopDrawerAutoShow, stopDrawerAutoDismissEpic, firstStopVieweed)
export default stopDrawerEpics
